<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<style>
  .container-items{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    justify-content: center;
  }
  .leaflet-popup-content{
    width: 300px!important;
  }
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4">
        <div class="vx-col w-full">
            <vx-card class="grid-view-item overflow-hidden">
                <div id="container-map" v-if="status_mapa">
                    <l-map :center="center" :zoom="10" ref="mymap" style="height: 100%; overflow: hidden;">
                        <l-control-layers :collapsed="true" :position="layersPosition" :sort-layers="true">
                        </l-control-layers>
                        <l-control :position="layersPosition">
                            <vs-button @click="status_filtrar = !status_filtrar" id="btn-control-search" icon="icon-search" icon-pack="feather" >
                            </vs-button>
                            <div class="centerx default-input" id="buscador" v-if="status_filtrar">
                                <v-select :options="alert_values" class="w-full margen" v-model="alert" :reduce="v => v.value"  :clearable="false">
                                </v-select>
                                <vs-input class="w-full margen" placeholder="Nombre" v-model="name">
                                </vs-input>
                                <vs-button @click="getMapa()" class="margen" color="dark" icon="icon-search" icon-pack="feather" style="float: right;" type="border">
                                    Filtrar
                                </vs-button>
                            </div>
                        </l-control>
                        <l-tile-layer :key="tileProvider.name" :name="tileProvider.name" :url="tileProvider.url" :visible="tileProvider.visible" layer-type="base" v-for="tileProvider in tileProviders">
                        </l-tile-layer>
                        <v-marker-cluster>
                            <l-marker :draggable="item.draggable" :key="item.id" :lat-lng.sync="item.position" :visible="item.visible" v-for="item in markers">
                                <l-icon :icon-anchor="staticAnchor">
                                    <img :src="require(`@/assets/images/markers/${item.alert}.svg`)" width="17px;"/>
                                </l-icon>
                                <l-popup>
                                    <div class="popup">

                                      <gridPrincipalItem
                                        img="agro"
                                        :name="item.name"
                                        :description="$t('Labels.Alias')"
                                      ></gridPrincipalItem>
                                      <vs-divider/>
                                      <div class="container-items">
                                        <valueItem
                                          :value="parseFloat(item.environment_temperature).toFixed(2)"
                                          :description="$t('Labels.EnvironmentTemperature')"
                                          unit="°C"
                                          img="pressure"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.environment_humidity).toFixed(2)"
                                          :description="$t('Labels.EnvironmentHumidity')"
                                          unit="%"
                                          img="pressure"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.environment_illumination).toFixed(2)"
                                          :description="$t('Labels.EnvironmentIllumination')"
                                          unit="%"
                                          img="pressure"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.environment_o2).toFixed(2)"
                                          :description="$t('Labels.EnvironmentO2')"
                                          unit="%"
                                          img="pressure"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.soil_temperature).toFixed(2)"
                                          :description="$t('Labels.SoilTemperature')"
                                          unit="°C"
                                          img="globe"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.soil_humidity).toFixed(2)"
                                          :description="$t('Labels.SoilHumidity')"
                                          unit="%"
                                          img="globe"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.soil_electric_conductivity).toFixed(2)"
                                          :description="$t('Labels.SoilElectricConductivity')"
                                          unit="us/cm"
                                          img="globe"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.soil_n).toFixed(2)"
                                          :description="$t('Labels.SoilN')"
                                          unit="mg/L"
                                          img="globe"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.soil_p).toFixed(2)"
                                          :description="$t('Labels.SoilP')"
                                          unit="mg/L"
                                          img="globe"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.soil_k).toFixed(2)"
                                          :description="$t('Labels.SoilK')"
                                          unit="mg/L"
                                          img="globe"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.soil_ph).toFixed(2)"
                                          :description="$t('Labels.SoilPH')"
                                          unit="PH"
                                          img="globe"
                                        ></valueItem>
                                        <valueItem
                                          :value="parseFloat(item.battery_status).toFixed(2)"
                                          :description="$t('Labels.Battery')"
                                          unit="%"
                                          img="battery"
                                        ></valueItem>
                                      </div>
                                      <vs-divider/>
                                      <valueItem
                                        :value="item.updated_at.split(' ')[0]"
                                        :description="item.updated_at.split(' ')[1]"
                                        img="fecha"
                                      ></valueItem>
                                      <alertItem :status="item.status === 1? true: false"></alertItem>

                                    <div class="text-center"><vs-button color="primary"  size="small" @click="deviceInformation(item.id)">Ver Más</vs-button></div>

                                </div>
                                </l-popup>
                            </l-marker>
                        </v-marker-cluster>
                    </l-map>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControl,
  LControlLayers
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import vSelect from 'vue-select'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import { request } from '@/request.js'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  name: 'mapa',
  components: {
    'v-select': vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
    LIcon,
    LControlLayers,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    gridPrincipalItem,
    valueItem,
    alertItem
  },
  data () {
    return {
      latlngs: [],
      response: [],
      name: '',
      alert: '',
      trayectoria: 0,
      alert_values: [
        { label: 'Todos', value: '' },
        { label: 'Correcto', value: 0 },
        { label: 'Alerta', value: 1 }
      ],
      tileProviders,
      layersPosition: 'topright',
      center: [20.662396323989693, -103.37640969334421],
      staticAnchor: [12, 27],
      markers: [],
      status_mapa: false,
      status_heat: false,
      status_filtrar: false
    }
  },
  methods: {
    async getMapa () {
      this.$vs.loading()
      const params = {
        url: 'modelo/agro/heatmap',
        method: 'GET',
        params: {
          description: this.name,
          transmite: this.alert
        }
      }
      await request(params).then(data => {
        data = data.data.data
        const positions = []
        for (const value of data) {
          positions.push([value.latlong.split(',')[0], value.latlong.split(',')[1]])
          this.markers.push({
            position: { lat: value.latlong.split(',')[0], lng: value.latlong.split(',')[1] },
            name: value.description,
            alert: value.status,
            updated_at: value.updated_at,
            id: value.agro_id,
            environment_temperature: value.environment_temperature,
            environment_humidity: value.environment_humidity,
            environment_illumination: value.environment_illumination,
            environment_o2: value.environment_o2,
            battery_status: value.battery_status,
            soil_temperature: value.soil_temperature,
            soil_humidity: value.soil_humidity,
            soil_electric_conductivity: value.soil_electric_conductivity,
            soil_n: value.soil_n,
            soil_p: value.soil_p,
            soil_k: value.soil_k,
            soil_ph: value.soil_ph,
            draggable: false,
            visible: true
          })
        }

        this.status_mapa = true
        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          maps.addControl(new L.Control.Fullscreen())
          maps.fitBounds(positions)
        }, 1000)
      }).catch(() => {
        this.markers = []
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    deviceInformation (uuid) {
      window.location.href = `/agro/detail/${uuid}`
    }

  },
  sockets: {
    agro (payload) {
      this.markers.forEach(markerToModify => {
        if (markerToModify.id === payload.uuid) {
          markerToModify.ahum = payload.ahum
          markerToModify.atemp = payload.atemp
          markerToModify.ground_hum = payload.ground_hum
          markerToModify.rain_level = payload.rain_level
          markerToModify.light_level = payload.light_level
          markerToModify.status = payload.status
        }
      })
    }
  },
  created () {
    this.getMapa()
  }

}
</script>
